<template>
  <v-card style="height: 100%">
    <div class="px-6 pt-4">
      <h4>Получаемые доходи филиалов</h4>
    </div>
    <v-card-text>
      <validation-observer v-slot="{handleSubmit}" class="row flex-md-row flex-column" tag="div">
        <div style="max-width: 250px" class="pa-2">
          <custom-autocomplete
            label="Филиалы"
            multiple
            hide-details
            rules="required"
            hide="details"
            prepend-item
            customSelection
            v-model="filterIncomeTable.mkos"
            :items="branches">
            <template v-slot:selection="{item, index}">
              <v-chip outlined v-if="index === 0">
                <span>{{ item.name }}</span>
              </v-chip>
              <span
                v-if="index === 1"
                class="grey--text caption"
              >(+{{ filterIncomeTable.mkos.length - 1 }})</span>
            </template>
            <template #prepend:item>
              <v-list-item v-ripple @click="isSelectedAllBranches ? filterIncomeTable.mkos=[] : selectAll()">
                <v-list-item-content>
                  <v-list-item-title>{{
                      isSelectedAllBranches ? 'Убрать все' : 'Выбрать все'
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </custom-autocomplete>
        </div>
        <div class="pa-2">
          <custom-date-picker
            hide="details"
            rules="required"
            v-model="filterIncomeTable.from"
            label="От"
          />
        </div>
        <div class="pa-2">
          <custom-date-picker
            rules="required"
            hide="details"
            label="До"
            v-model="filterIncomeTable.to"
          />
        </div>
        <div class="pa-2">

          <v-btn :loading="loading" :width="$vuetify.breakpoint.mdAndDown ? '100%' : null" small height="38"
                 color="primary"
                 @click="handleSubmit(getIncomeData)">
            Получить данные
          </v-btn>
        </div>
      </validation-observer>
      <v-simple-table class="table-wth-border">
        <thead>
        <tr>
          <th rowspan="2">Филиал</th>
          <th colspan="3">Общая сумма для оплаты</th>
          <th colspan="3">Общая оплаченная сумма</th>
          <th colspan="3">Общее остаток для оплаты</th>
        </tr>
        <tr>
          <th>Основная сумма</th>
          <th>Процент</th>
          <th>Общее</th>
          <th>Основная сумма</th>
          <th>Процент</th>
          <th>Общее</th>
          <th>Основная сумма</th>
          <th>Процент</th>
          <th>Общее</th>
        </tr>
        </thead>
        <tbody class="text-no-wrap">
        <tr
          v-for="(item, index) in incomeTableItems"
          :key="`row-${index}`"
        >
          <td>{{ item.mko }}</td>

          <td>{{ item.main_must_be_paid|numberToString }}</td>
          <td>{{ item.all_must_be_paid |numberToString}}</td>
          <td>{{ item.all_must_be_paid|numberToString }}</td>

          <td>{{ item.main_paid|numberToString }}</td>
          <td>{{ item.percent_paid|numberToString }}</td>
          <td>{{ item.paid|numberToString }}</td>

          <td>{{ item.main_residue|numberToString }}</td>
          <td>{{ item.percent_residue |numberToString}}</td>
          <td>{{ item.all_residue|numberToString }}</td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
const currentDate = new Date()
export default {
  name: 'DashboardIncomeTable',
  data() {
    return {
      branches: [],
      loading: false,
      incomeTableHeaders: [
        {
          text: 'Общая сумма для оплаты',
          value: 'all_must_be_paid'
        },
        {
          text: 'Основная сумма',
          value: 'main_must_be_paid'
        },
        {
          text: 'Процент',
          value: 'percent_must_be_paid'
        },
        {
          text: 'Процент',
          value: 'percent_must_be_paid'
        }
      ],
      filterIncomeTable: {
        "mkos": [],
        "from": `${currentDate.getFullYear()}-01-01`,
        "to": new Date().toISOString().substr(0, 10),
      },
      incomeTableItems: []
    }
  },
  computed: {
    isSelectedAllBranches() {
      return this.filterIncomeTable.mkos.length === this.branches.length
    }
  },
  methods: {
    selectAll() {
      this.filterIncomeTable.mkos = this.branches.map(item => {
        return item.id
      })
    },
    async getIncomeData() {
      try {
        this.loading = true
        const {data: {data}} = await this.$http.get('admin/dashboard/income', {
          params: this.filterIncomeTable
        })
        this.incomeTableItems = data
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.loading = false
      }
    }
  },
  async created() {
    try {
      this.branches = await this.$store.dispatch('getMkos')
    } catch (e) {
      this.$setResponseError({error: e})
    }
  }
}
</script>